var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookingLogoSolidSquare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 2500 2445"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0c3b7c",
  fillRule: "evenodd",
  d: "M.1 0H2500v2445H.1z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m1136.2 1618.4-201.4-.2v-240.8c0-51.4 20-78.2 64-84.3h137.4c98 0 161.3 61.8 161.3 161.7 0 102.7-61.7 163.5-161.3 163.6M934.8 969v-63.4c0-55.5 23.5-81.8 74.9-85.2h103.1c88.3 0 141.3 52.8 141.3 141.4 0 67.4-36.3 146.1-138.1 146.1H934.8zm458.5 240.2-36.4-20.5 31.8-27.2c37-31.8 99-103.3 99-226.6 0-188.9-146.5-310.8-373.2-310.8H855.7v-.1h-29.5c-67.2 2.5-121 57.2-121.7 124.7v1072h415c252 0 414.6-137.2 414.6-349.7.1-114.3-52.4-212-140.8-261.8"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#00bafc",
  d: "M1642.3 1672.7c0-81.9 66-148.1 147.4-148.1 81.6 0 147.9 66.3 147.9 148.1s-66.4 148.1-147.9 148.1c-81.4.1-147.4-66.3-147.4-148.1"
})));
export { SvgBookingLogoSolidSquare as ReactComponent };
export default __webpack_public_path__ + "3e0aee76cc0814374d3eed99b8c91428.svg";